import { render, staticRenderFns } from "./ParticipantsDetails.vue?vue&type=template&id=6acd106b&scoped=true"
import script from "./ParticipantsDetails.vue?vue&type=script&lang=js"
export * from "./ParticipantsDetails.vue?vue&type=script&lang=js"
import style0 from "./ParticipantsDetails.vue?vue&type=style&index=0&id=6acd106b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acd106b",
  null
  
)

export default component.exports